import axios, { AxiosResponse } from "axios";
import UserService from "./UserService";
import OrderModel, { OrderPagination } from "../models/Order";

const API_BASE_URL = window._env_.REACT_APP_PAROLA_API_URL;
const API_RESOURCE = "order";

export default class OrderService {
  public static async getOrder(
    assemblyCode: string,
  ): Promise<OrderModel | null> {
    try {
      const response: AxiosResponse<OrderModel> = await axios.get(
        API_BASE_URL + API_RESOURCE + "/" + assemblyCode,
        {
          headers: UserService.getAuthHeader(),
        },
      );
      const order = response.data;
      return order;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public static async getAll(
    skip: number = 1,
    limit: number = 10,
    clientFilter?: string,
    orderNumberFilter?: string,
    startDate?: string,
    endDate?: string,
    preload: boolean = false,
    signal?: AbortSignal,
  ): Promise<OrderPagination | null> {
    try {
      const params = new URLSearchParams();
      params.append("page", skip.toString());
      params.append("page_size", limit.toString());
      if (clientFilter) params.append("client", clientFilter);
      if (orderNumberFilter) params.append("order_number", orderNumberFilter);
      if (startDate) params.append("start_date", startDate);
      if (endDate) params.append("end_date", endDate);
      params.append("preload", preload.toString());

      const response: AxiosResponse<OrderPagination> = await axios.get(
        `${API_BASE_URL}${API_RESOURCE}?${params.toString()}`,
        {
          headers: {
            accept: "application/json",
            "api-key": "ParolaAlgolabs2025",
          },
          signal,
        },
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
